import React from "react";
import { mercury } from "@bfme-technology/styled";
import { FederatedModule } from "@bfme-technology/spa";
import { getResolvedMfeProps } from "../Dashboard.utils";



import type { MetricsCardsProps } from './MetricsCards.types';

export const MetricsCards: React.FC<MetricsCardsProps> = ({
  routesLoading = false,
  routes = [],
}) => {
  // Find mfe-investing route
  const investingRoute = routes.find((r) => r.key === "mfe-investing");
  const resolvedInvesting = investingRoute
    ? getResolvedMfeProps(investingRoute)
    : null;
  const investingMfeProps = resolvedInvesting
    ? (() => {
        const { key, ...rest } = resolvedInvesting;
        return rest;
      })()
    : null;

  return (
    <div className={mercury.metricsGridClass}>
      {/* Stat Card 1: Net Worth */}
      {(() => {
        if (routesLoading) {
          return (
            <section
              className={`${mercury.metricCardClass} items-center justify-center`}
            >
              <div className="text-text-muted text-xs p-4 text-center">
                Loading Net Worth...
              </div>
            </section>
          );
        }
        if (!investingMfeProps) {
          return (
            <section
              className={`${mercury.metricCardClass} items-center justify-center`}
            >
              <div className="text-red-500 text-xs p-4 text-center">
                Net Worth MFE config not found.
              </div>
            </section>
          );
        }
        return (
          <FederatedModule
            {...investingMfeProps}
            mfeType="federated"
            scope="mfe_investing"
            module="./NetWorthTracker"
          />
        );
      })()}

      {/* Stat Card 2: Portfolio Sparkline */}
      {(() => {
        if (routesLoading) {
          return (
            <section
              className={`${mercury.metricCardClass} items-center justify-center`}
            >
              <div className="text-text-muted text-xs p-4 text-center">
                Loading Portfolio...
              </div>
            </section>
          );
        }
        if (!investingMfeProps) {
          return (
            <section
              className={`${mercury.metricCardClass} items-center justify-center`}
            >
              <div className="text-red-500 text-xs p-4 text-center">
                Portfolio MFE config not found.
              </div>
            </section>
          );
        }
        return (
          <FederatedModule
            {...investingMfeProps}
            mfeType="federated"
            scope="mfe_investing"
            module="./PortfolioValue"
          />
        );
      })()}

      {/* Stat Card 3: Expenses Budget MFE */}
      {(() => {
        if (routesLoading) {
          return (
            <section
              className={`${mercury.metricCardClass} sm:col-span-2 lg:col-span-1 items-center justify-center`}
            >
              <div className="text-text-muted text-xs p-4 text-center">
                Loading Expense Metric...
              </div>
            </section>
          );
        }
        const route = routes.find((r) => r.key === "mfe-expense-manager");
        if (!route) {
          return (
            <section
              className={`${mercury.metricCardClass} sm:col-span-2 lg:col-span-1 items-center justify-center`}
            >
              <div className="text-red-500 text-xs p-4 text-center">
                MFE config not found.
              </div>
            </section>
          );
        }
        const resolved: any = getResolvedMfeProps(route);
        const { key, ...mfeProps } = resolved;
        return (
          <FederatedModule
            {...mfeProps}
            mfeType="federated"
            scope="mfe_expense_manager"
            module="./MonthlyExpense"
          />
        );
      })()}
    </div>
  );
};
